import { render, staticRenderFns } from "./desireDharma.vue?vue&type=template&id=3ee8c75f&scoped=true&"
import script from "./desireDharma.vue?vue&type=script&lang=js&"
export * from "./desireDharma.vue?vue&type=script&lang=js&"
import style0 from "./desireDharma.vue?vue&type=style&index=0&id=3ee8c75f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee8c75f",
  null
  
)

export default component.exports